<template>
    <TabSelect
        :options="options"
        :value="value"
        :name="name"
        @input="$emit('input', $event)">
    </TabSelect>
</template>

<script>
    // ForumTabSelect: stylizes the tab select input for the forum.

    import TabSelect from '../tab-select';

    export default {
        // See src/components/reusable/tab-select/index.vue for prop details
        props: ['options', 'value', 'name'],

        components: {
            TabSelect,
        },

        mounted() {
            this.$el.classList.add('forum-tab-select');
        },
    }
</script>

<style lang="scss">
    .forum-tab-select.tab-select {
        .option {
            padding: 0;
            height: 40px;
            line-height: 40px;
            margin-left: 20px;

            &:hover {
                background: none;
            }

            &:first-of-type {
                margin-left: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// tab-select.vue?50b3e9e8